export default "__VITE_ASSET__BTHVyPGx__"